let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GeES")).then(() => parcelRequire('as0vE'));